import { normalizeSeasonRailcards } from "../lib/seasonRailcards";

export const getSeasonRailcards = async (seasonRailcardsApi) => {
  try {
    const response = await seasonRailcardsApi?.get();
    return normalizeSeasonRailcards(response.data);
  } catch (error) {
    console.log('Get Season Railcards Error: ', error);
  }
};
